import { INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210 } from "@faire/web-api--source/indigofair/settings/INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingTrackInsightCardProductImpressions = () => {
  return useSetting(INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210, false);
};

export const useAssignSettingTrackInsightCardProductImpressions = () => {
  return useAssignSetting(INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210);
};
